import React, { useState } from 'react'
import { useFormik } from 'formik'
import * as yup from 'yup'

import './AddChannelCodeForm.css'

import FormStatus from '../FormStatus'
import Input from '../../formControls/Input'
import Button from '../../buttons/Button'

const AddChannelCodeForm = ({ data, onSubmit }) => {
   const [disableSubmitBtn, setDisableSubmitBtn] = useState(false)

   const formik = useFormik({
      initialValues: {
         code: ''
      },
      validationSchema: yup.object().shape({
         code: yup.string()
            .min(4, 'Код, полученный вами в приложении должен содержать минимум 4 символа.')
            .required('Введите код подтверждения'),
      }),
      onSubmit: async ({ code }, { setStatus }) => {
         try {
            setDisableSubmitBtn(true)
            await onSubmit({
               code,
               sourceId: data
            })
         } catch (err) {
            setStatus(err)
         } finally {
            setDisableSubmitBtn(false)
         }
      }
   })

   return (
      <form 
         className='add-channel-code-form'
         onSubmit={formik.handleSubmit}   
      >
         {formik.status && <FormStatus text={formik.status} />}
         <Input
            label='Код подтверждения'
            id='code'
            name='code'
            value={formik.values.code}
            error={formik.touched.code && formik.errors.code}
            placeholder='55500'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            maxLength={5}
            autoComplete='off'
         />
         <Button
            className='add-channel-code-form__submit-btn'
            type='submit'
            text='Добавить канал'
            disabled={disableSubmitBtn}
         />
      </form>
   )
}

export default AddChannelCodeForm